import { render } from "./AdvisorOverrideEdit.vue?vue&type=template&id=22e4c7c8"
import script from "./AdvisorOverrideEdit.vue?vue&type=script&lang=js"
export * from "./AdvisorOverrideEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__